module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG1003-572788882b54bb928cb2c63955dfc144.png";